/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Suspense, useEffect } from 'react';
import { RouterProvider } from 'react-router/dom';

import { BootScreen } from '@/components/loading/BootScreen';
import { BOOT_SPLASH_FAILSAFE_MS, dismissBootSplash } from '@/components/loading/bootSplash';
import { router } from '@/routes/router';

export function App() {
  // Whichever surface becomes interactive first normally takes the splash down. This is the
  // backstop, for a gate that never resolves.
  useEffect(() => {
    const timer = window.setTimeout(dismissBootSplash, BOOT_SPLASH_FAILSAFE_MS);
    return () => window.clearTimeout(timer);
  }, []);

  return (
    // AppShell's boundary only wraps its own <Outlet />, so without this a suspending top-level
    // route element renders nothing at all.
    <Suspense fallback={<BootScreen />}>
      <RouterProvider router={router} />
    </Suspense>
  );
}
